(function($) {

	var config = {
		defaultClass: "text-default",
		attribute: "placeholder",
		isHtml5: window.history.replaceState
	};

	$.fn.defaultValue = function(value) {
		return this.each(function() {
			// Don't bother adding the functionality if we're using HTML5
			if (!config.isHtml5) {
				var $el = $(this);

				// Setup the placeholder attr
				if (value) {
					$el.attr(config.attribute, value);
				}

				// Add the default class if needed
				if (!$el.hasClass(config.defaultClass)) {
					$el.addClass(config.defaultClass);
				}

				// Setup the initial value
				if (!$el.val()) {
					$el.val($el.attr(config.attribute));
				}

				$el.on("focus", function(e) {
					var $target = $(e.currentTarget);

					if ($target.val() == $target.attr(config.attribute)) {
						$target
							.removeClass(config.defaultClass)
							.val("");
					}
				});

				$el.on("blur", function(e) {
					var $target = $(e.currentTarget);

					if (!$target.val()) {
						$target
							.addClass(config.defaultClass)
							.val($target.attr(config.attribute));
					}
				});
			}
		});
	};

})(jQuery);